export class ManageColumnResult {
  constructor(public reloadGrid: boolean, public isDefaultGrid: boolean) {}
}
